export default __webpack_public_path__ + "static/media/7-clapping-hands_1f44f.9a11ba7e.png";